import type { TFunction } from '@tuic/i18n';
import type { PaginationProps } from '@tuic/web-compositions/core/Pagination';

export const getI18nForPagination = (t: TFunction): PaginationProps['i18n'] => {
  return {
    page: t('Seite'),
    previousPage: t('Vorherige Seite'),
    nextPage: t('Nächste Seite'),
    paginationNavigation: t('Navigation'),
  };
};
